import type { WorkspaceMember } from '@modules/projects/project-members.interface'

import { findInviteEmailConflict } from './findInviteEmailConflict'
import { InviteEmailConflict } from './invite-email-conflict.enum'
import type { InviteEmailConflictScope } from './InviteEmailConflictError'
import { InviteEmailConflictError } from './InviteEmailConflictError'

export const assertNoInviteEmailConflict = (
  members: WorkspaceMember[],
  email: string,
  scope: InviteEmailConflictScope
): void => {
  const conflict = findInviteEmailConflict(members, email)
  if (conflict === InviteEmailConflict.ALREADY_MEMBER) {
    throw new InviteEmailConflictError(conflict, scope)
  }
}
